<template lang="html">
  <div class="CsHeader" :style="`background-image: url(${contents.header});`">
    <img src="./logo.png" alt="京东金融" class="logo">
    <div class="rule">
      <a :href="contents.rule" clstag="jr|keycount|zy|gz">活动规则</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CsHeader',
  data () {
    return {
      contents: window.contentData.contents
    }
  }
}
</script>

<style lang="scss" scoped>
.CsHeader{
  height: 300px;
  width: 100%;
  // background-color: black;
  position: relative;
  // background-image: url(./header.png);
  background-size: 100%;
  background-position: top center;
  background-repeat: no-repeat;

  .logo{
    position: absolute;
    top: 15px;
    left: 15px;
    width: 79px;
    height: 26.5px;
  }

  .rule{
    position: absolute;
    box-sizing: border-box;
    width: 80px;
    height: 30px;
    top: 10px;
    right: 0;
    padding: 6px 8px 6px 13px;
    background-color: rgba(255,255,255,0.32);
    border-radius: 23px 0 0 23px;

    a{
      font-family: 'PingFang-SC-Regular';
      font-size: 13px;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      text-decoration: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CsHeader/index.vue